import { Components } from '@mui/material/styles';
import palette from 'theme/palette';

export const MuiSkeleton: Components['MuiSkeleton'] = {
  styleOverrides: {
    root: {
      backgroundColor: palette.grey[200],
      '&:after': {
        background: `
                linear-gradient(
                    90deg,
                    transparent,
                    rgba(0, 0, 0, 0.01),
                    transparent
                  )`,
      },
    },
  },
};
